var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenceConflict(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "276px",
    height: "266px",
    viewBox: "0 0 276 266",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "licence-conflict") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.878602,5.27246094 L125.042201,47.2924227 C124.360894,50.9456915 124.710928,54.7165339 126.053039,58.181976 L159.780612,145.269357 C161.226838,149.003631 161.518752,153.086066 160.618563,156.98812 L156.114967,176.509874 L99.3613281,175.46582 L88.3144531,5.27246094 L132.878602,5.27246094 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-2.0%",
    width: "119.2%",
    height: "104.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0358355978 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.861875,-7.10542736e-15 L126.042201,47.2924227 C125.360894,50.9456915 125.710928,54.7165339 127.053039,58.181976 L160.780612,145.269357 C162.226838,149.003631 162.518752,153.086066 161.618563,156.98812 L155.848416,182 L0,182 L0,0 L134.861875,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 61,
    height: 77,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0 L84.9570312,13.2890625 L119.886719,41.0117188 L159,48.1796875 L159,235.339844 L119.886719,246.5 L55.65625,282.359375 L19,282.359375 L36.6185631,205.98812 C37.5187524,202.086066 37.2268375,198.003631 35.7806121,194.269357 L2.0530391,107.181976 C0.710927868,103.716534 0.360893996,99.9456915 1.04220065,96.2924227 L19,0 L9,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 61,
    height: 77,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-11",
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08826265,3.04312248 L6.37035962,0.476872278 L14.3916084,0.476872278 L12.6737054,3.04312248 C11.9139643,4.17804426 10.2715862,4.54605861 9.00535119,3.86510554 C8.62902199,3.66272406 8.31406017,3.38042494 8.08826265,3.04312248 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6966543,7.27389171 L12.9787512,4.70764151 L21,4.70764151 L19.282097,7.27389171 C18.5223559,8.40881349 16.8799778,8.77682784 15.6137428,8.09587477 C15.2374136,7.89349329 14.9224518,7.61119417 14.6966543,7.27389171 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69665426,7.27389171 L-0.0212487708,4.70764151 L8,4.70764151 L6.28209697,7.27389171 C5.52235595,8.40881349 3.87997784,8.77682784 2.6137428,8.09587477 C2.2374136,7.89349329 1.92245177,7.61119417 1.69665426,7.27389171 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69665426,15.2738917 L1.97875123,12.7076415 L10,12.7076415 L8.28209697,15.2738917 C7.52235595,16.4088135 5.87997784,16.7768278 4.6137428,16.0958748 C4.2374136,15.8934933 3.92245177,15.6111942 3.69665426,15.2738917 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8878563,14.8288173 L10.1699533,12.2625671 L18.1912021,12.2625671 L16.473299,14.8288173 C15.713558,15.9637391 14.0711799,16.3317535 12.8049449,15.6508004 C12.4286157,15.4484189 12.1136538,15.1661198 11.8878563,14.8288173 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1416902,3.43991257 L8,0 L18,0 L15.8583098,3.43991257 C14.9111492,4.96121072 12.863615,5.45451305 11.2850141,4.54173416 C10.8158488,4.27045329 10.4231895,3.89204735 10.1416902,3.43991257 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1416902,8.43991257 L15,5 L25,5 L22.8583098,8.43991257 C21.9111492,9.96121072 19.863615,10.454513 18.2850141,9.54173416 C17.8158488,9.27045329 17.4231895,8.89204735 17.1416902,8.43991257 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14169025,8.43991257 L0,5 L10,5 L7.85830975,8.43991257 C6.91114922,9.96121072 4.86361504,10.454513 3.28501415,9.54173416 C2.8158488,9.27045329 2.42318946,8.89204735 2.14169025,8.43991257 Z",
    id: "path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14169025,17.4399126 L2,14 L12,14 L9.85830975,17.4399126 C8.91114922,18.9612107 6.86361504,19.454513 5.28501415,18.5417342 C4.8158488,18.2704533 4.42318946,17.8920474 4.14169025,17.4399126 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1416902,17.4399126 L12,14 L22,14 L19.8583098,17.4399126 C18.9111492,18.9612107 16.863615,19.454513 15.2850141,18.5417342 C14.8158488,18.2704533 14.4231895,17.8920474 14.1416902,17.4399126 Z",
    id: "path-22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broken-Driving-Licence-Type",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-338.000000, -257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "licence-conflict",
    transform: "translate(332.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    fill: "#F2F9FA",
    cx: 144,
    cy: 140,
    r: 133
  }), /*#__PURE__*/React.createElement("g", {
    id: "provisional",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-19",
    stroke: "none",
    fill: "#E8FDDA",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 276,
    height: 172,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 16,
    y: 46,
    width: 61,
    height: 77,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 16,
    y: 8,
    width: 61,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2553578,23.730594 L53.0363599,23.730594 L53.0363599,29.9837597 L38.9636401,29.9837597 L38.9636401,23.730594 L39.0021921,23.730594 L39.0021921,16 L45.2553578,16 L45.2553578,23.730594 Z",
    id: "Combined-Shape",
    stroke: "#CC0033",
    strokeWidth: 1,
    fill: "#CC0033",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Provisional-Driving",
    stroke: "none",
    fill: "none",
    fontFamily: "GothamRounded-Bold, Gotham Rounded",
    fontSize: 12,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 87.038,
    y: 26,
    fill: "#364344"
  }, "Provisional Driving Licence")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 43,
    width: 115,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 59,
    width: 115,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 82,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 98,
    width: 93,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 114,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    stroke: "none",
    fill: "#B5EBD1",
    fillRule: "evenodd",
    x: 104,
    y: 130,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF007",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(16.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B5EBD1",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4472656,55.3339844 C56.1347656,55.9199219 60.0654289,57.9707031 63.2392578,61.4863281 C66.4130867,65.0019531 68,69.152343 68,73.9375 L68,78.0390625 C68,80.7734382 67.0234368,83.1171882 65.0703125,85.0703125 C63.1171882,87.0234368 60.8222656,88 58.1855469,88 L2.9609375,88 C0.226561755,88 -2.11718825,87.0234368 -4.0703125,85.0703125 C-6.02343675,83.1171882 -7,80.7734382 -7,78.0390625 L-7,73.9375 C-7,69.152343 -5.41308668,65.0019531 -2.23925781,61.4863281 C0.934571058,57.9707031 4.86523438,55.9199219 9.55273438,55.3339844 C5.93945238,50.6464844 4.1328125,45.3242195 4.1328125,39.3671875 C4.1328125,34.5820305 5.3046875,30.1630867 7.6484375,26.1103516 C9.9921875,22.0576164 13.1904289,18.859375 17.2431641,16.515625 C21.2958992,14.171875 25.714843,13 30.5,13 C35.285157,13 39.7041008,14.171875 43.7568359,16.515625 C47.8095711,18.859375 51.0078125,22.0576164 53.3515625,26.1103516 C55.6953125,30.1630867 56.8671875,34.5820305 56.8671875,39.3671875 C56.8671875,45.3242195 55.0605476,50.6464844 51.4472656,55.3339844 Z M30.5,20 C26.9545455,20 23.7045455,20.8863636 20.75,22.6590909 C17.7954545,24.4318182 15.4318182,26.7954545 13.6590909,29.75 C11.8863636,32.7045455 11,35.9545455 11,39.5 C11,43.0454545 11.8863636,46.2954545 13.6590909,49.25 C15.4318182,52.2045455 17.7954545,54.5681818 20.75,56.3409091 C23.7045455,58.1136364 26.9545455,59 30.5,59 C34.0454545,59 37.2954545,58.1136364 40.25,56.3409091 C43.2045455,54.5681818 45.5681818,52.2045455 47.3409091,49.25 C49.1136364,46.2954545 50,43.0454545 50,39.5 C50,35.9545455 49.1136364,32.7045455 47.3409091,29.75 C45.5681818,26.7954545 43.2045455,24.4318182 40.25,22.6590909 C37.2954545,20.8863636 34.0454545,20 30.5,20 Z M61,78.03125 L61,73.875 C61,70.609375 59.8513629,67.8138028 57.5540865,65.4882812 C55.2568102,63.1627597 52.4951923,62 49.2692308,62 L43.6971154,62 C39.5913462,64.375 35.1923077,65.5625 30.5,65.5625 C25.8076923,65.5625 21.4086538,64.375 17.3028846,62 L11.7307692,62 C8.50480769,62 5.74318985,63.1627597 3.44591346,65.4882812 C1.14863707,67.8138028 0,70.609375 0,73.875 L0,78.1796875 C0,78.9713534 0.268829382,79.6393222 0.806490385,80.1835938 C1.34415139,80.7278653 2.05288462,81 2.93269231,81 L58.2139423,81 C58.9959928,81 59.6558486,80.7278653 60.1935096,80.1835938 C60.7311706,79.6393222 61,78.921875 61,78.03125 Z",
    fill: "#8FD9B5",
    mask: "url(#mask-6)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "full",
    transform: "translate(138.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-19",
    fill: "#FFE5F6",
    x: 0,
    y: 0,
    width: 276,
    height: 172,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    fill: "#B5EBD1",
    x: 16,
    y: 46,
    width: 61,
    height: 77,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0848B4",
    x: 16,
    y: 8,
    width: 61,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5857988,27 C40.3609467,27 39,25.8284519 39,23.5299861 L39,19.8591353 C39,19.3793584 39.4023669,19 39.9112426,19 C40.4201183,19 40.8224852,19.3793584 40.8224852,19.8591353 L40.8224852,23.4853556 C40.8224852,24.7573222 41.4970414,25.4156206 42.6094675,25.4156206 C43.7218935,25.4156206 44.3964497,24.7796374 44.3964497,23.5411437 L44.3964497,19.8591353 C44.3964497,19.3793584 44.7988166,19 45.3076923,19 C45.816568,19 46.2189349,19.3793584 46.2189349,19.8591353 L46.2189349,23.474198 C46.2189349,25.8396095 44.8106509,27 42.5857988,27 Z M48.0769231,26.0850767 L48.0769231,19.8591353 C48.0769231,19.3793584 48.4792899,19 48.9881657,19 C49.4970414,19 49.8994083,19.3793584 49.8994083,19.8591353 L49.8994083,22.4811715 L53.260355,19.334728 C53.4852071,19.1227336 53.7100592,19 54.0295858,19 C54.5384615,19 54.8698225,19.3682008 54.8698225,19.7921897 C54.8698225,20.0599721 54.739645,20.2608089 54.5384615,20.4393305 L52.2071006,22.4923291 L54.7514793,25.5048815 C54.8934911,25.6722455 55,25.8507671 55,26.1073919 C55,26.5871688 54.6094675,26.944212 54.0769231,26.944212 C53.7218935,26.944212 53.5088757,26.776848 53.3076923,26.5313808 L50.9408284,23.6080893 L49.8994083,24.5230126 L49.8994083,26.0850767 C49.8994083,26.5648536 49.4970414,26.944212 48.9881657,26.944212 C48.4792899,26.944212 48.0769231,26.5648536 48.0769231,26.0850767 Z",
    id: "UK",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 43,
    width: 115,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 59,
    width: 115,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 82,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 98,
    width: 93,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 114,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#F5CDE7",
    x: 104,
    y: 130,
    width: 74,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF007",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(16.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F5CDE7",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4472656,55.3339844 C56.1347656,55.9199219 60.0654289,57.9707031 63.2392578,61.4863281 C66.4130867,65.0019531 68,69.152343 68,73.9375 L68,78.0390625 C68,80.7734382 67.0234368,83.1171882 65.0703125,85.0703125 C63.1171882,87.0234368 60.8222656,88 58.1855469,88 L2.9609375,88 C0.226561755,88 -2.11718825,87.0234368 -4.0703125,85.0703125 C-6.02343675,83.1171882 -7,80.7734382 -7,78.0390625 L-7,73.9375 C-7,69.152343 -5.41308668,65.0019531 -2.23925781,61.4863281 C0.934571058,57.9707031 4.86523438,55.9199219 9.55273438,55.3339844 C5.93945238,50.6464844 4.1328125,45.3242195 4.1328125,39.3671875 C4.1328125,34.5820305 5.3046875,30.1630867 7.6484375,26.1103516 C9.9921875,22.0576164 13.1904289,18.859375 17.2431641,16.515625 C21.2958992,14.171875 25.714843,13 30.5,13 C35.285157,13 39.7041008,14.171875 43.7568359,16.515625 C47.8095711,18.859375 51.0078125,22.0576164 53.3515625,26.1103516 C55.6953125,30.1630867 56.8671875,34.5820305 56.8671875,39.3671875 C56.8671875,45.3242195 55.0605476,50.6464844 51.4472656,55.3339844 Z M30.5,20 C26.9545455,20 23.7045455,20.8863636 20.75,22.6590909 C17.7954545,24.4318182 15.4318182,26.7954545 13.6590909,29.75 C11.8863636,32.7045455 11,35.9545455 11,39.5 C11,43.0454545 11.8863636,46.2954545 13.6590909,49.25 C15.4318182,52.2045455 17.7954545,54.5681818 20.75,56.3409091 C23.7045455,58.1136364 26.9545455,59 30.5,59 C34.0454545,59 37.2954545,58.1136364 40.25,56.3409091 C43.2045455,54.5681818 45.5681818,52.2045455 47.3409091,49.25 C49.1136364,46.2954545 50,43.0454545 50,39.5 C50,35.9545455 49.1136364,32.7045455 47.3409091,29.75 C45.5681818,26.7954545 43.2045455,24.4318182 40.25,22.6590909 C37.2954545,20.8863636 34.0454545,20 30.5,20 Z M61,78.03125 L61,73.875 C61,70.609375 59.8513629,67.8138028 57.5540865,65.4882812 C55.2568102,63.1627597 52.4951923,62 49.2692308,62 L43.6971154,62 C39.5913462,64.375 35.1923077,65.5625 30.5,65.5625 C25.8076923,65.5625 21.4086538,64.375 17.3028846,62 L11.7307692,62 C8.50480769,62 5.74318985,63.1627597 3.44591346,65.4882812 C1.14863707,67.8138028 0,70.609375 0,73.875 L0,78.1796875 C0,78.9713534 0.268829382,79.6393222 0.806490385,80.1835938 C1.34415139,80.7278653 2.05288462,81 2.93269231,81 L58.2139423,81 C58.9959928,81 59.6558486,80.7278653 60.1935096,80.1835938 C60.7311706,79.6393222 61,78.921875 61,78.03125 Z",
    fill: "#EBA8D4",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wheels",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(220.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.000000, 20.000000) rotate(16.000000) translate(-21.000000, -20.000000) translate(4.000000, 5.000000)",
    fill: "#AE9977",
    stroke: "#FFE5F6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1602366,29.2260694 C22.5733808,29.2260694 26.2750518,23.9455077 26.2750518,16.5323635 C26.2750518,9.11921943 23.8342945,4.06868357 16.4211504,4.06868357 C9.00800628,4.06868357 0.425051418,10.9391298 0.425051418,18.3522739 C0.425051418,25.765418 7.74709253,29.2260694 15.1602366,29.2260694 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1650391,29.1582031 C29.7254527,29.1582031 34,23.0604136 34,14.5 C34,5.93958638 31.1815074,0.107421875 22.6210938,0.107421875 C14.0606801,0.107421875 4.14941406,8.04114888 4.14941406,16.6015625 C4.14941406,25.1619761 12.6046254,29.1582031 21.1650391,29.1582031 Z",
    id: "Oval"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFE5F6",
    fill: "#AE9977",
    cx: 27.5,
    cy: 20.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFE5F6",
    fill: "#AE9977",
    cx: 27.5,
    cy: 20.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(18.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#AE9977",
    transform: "translate(9.500000, 9.500000) scale(-1, 1) translate(-9.500000, -9.500000) ",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    mask: "url(#mask-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -1.000000)",
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M6.84177432,3.87754855 L3.56115633,-1.02312772 L17.2008117,-1.02312772 L13.9201937,3.87754855 C12.7221059,5.66728464 10.2285025,6.22603652 8.29490182,5.18618907 C7.70565692,4.86930626 7.20571024,4.4212059 6.84177432,3.87754855 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(16.989376, 6.572696) rotate(64.000000) translate(-16.989376, -6.572696) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M13.4501659,8.10831778 L10.1695479,3.20764151 L23.8092033,3.20764151 L20.5285853,8.10831778 C19.3304975,9.89805387 16.8368941,10.4568058 14.9032934,9.41695831 C14.3140485,9.10007549 13.8141019,8.65197514 13.4501659,8.10831778 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(3.989376, 6.572696) scale(-1, 1) rotate(64.000000) translate(-3.989376, -6.572696) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M0.450165933,8.10831778 L-2.83045206,3.20764151 L10.8092033,3.20764151 L7.5285853,8.10831778 C6.3304975,9.89805387 3.83689406,10.4568058 1.90329343,9.41695831 C1.31404853,9.10007549 0.814101851,8.65197514 0.450165933,8.10831778 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(5.989376, 14.572696) scale(-1, -1) rotate(44.000000) translate(-5.989376, -14.572696) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M2.45016593,16.1083178 L-0.830452064,11.2076415 L12.8092033,11.2076415 L9.5285853,16.1083178 C8.3304975,17.8980539 5.83689406,18.4568058 3.90329343,17.4169583 C3.31404853,17.1000755 2.81410185,16.6519751 2.45016593,16.1083178 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(14.180578, 14.127622) scale(1, -1) rotate(44.000000) translate(-14.180578, -14.127622) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M10.641368,15.6632434 L7.36075001,10.7625671 L21.0004054,10.7625671 L17.7197874,15.6632434 C16.5216996,17.4529795 14.0280961,18.0117314 12.0944955,16.9718839 C11.5052506,16.6550011 11.0053039,16.2069008 10.641368,15.6632434 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M8.86832128,4.23271234 L5.29913344,-1.5 L20.7008666,-1.5 L17.1316787,4.23271234 C15.7537518,6.44589329 12.808659,7.15543999 10.5341671,5.84028285 C9.85294203,5.44638477 9.2804719,4.89469513 8.86832128,4.23271234 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(20.000000, 7.500000) rotate(64.000000) translate(-20.000000, -7.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M15.8683213,9.23271234 L12.2991334,3.5 L27.7008666,3.5 L24.1316787,9.23271234 C22.7537518,11.4458933 19.808659,12.15544 17.5341671,10.8402828 C16.852942,10.4463848 16.2804719,9.89469513 15.8683213,9.23271234 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(5.000000, 7.500000) scale(-1, 1) rotate(64.000000) translate(-5.000000, -7.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M0.868321282,9.23271234 L-2.70086656,3.5 L12.7008666,3.5 L9.13167872,9.23271234 C7.75375182,11.4458933 4.80865904,12.15544 2.53416709,10.8402828 C1.85294203,10.4463848 1.2804719,9.89469513 0.868321282,9.23271234 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(7.000000, 16.500000) scale(-1, -1) rotate(44.000000) translate(-7.000000, -16.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M2.86832128,18.2327123 L-0.700866559,12.5 L14.7008666,12.5 L11.1316787,18.2327123 C9.75375182,20.4458933 6.80865904,21.15544 4.53416709,19.8402828 C3.85294203,19.4463848 3.2804719,18.8946951 2.86832128,18.2327123 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Triangle-2",
    transform: "translate(17.000000, 16.500000) scale(1, -1) rotate(44.000000) translate(-17.000000, -16.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AE9977",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE5F6",
    strokeWidth: 3,
    d: "M12.8683213,18.2327123 L9.29913344,12.5 L24.7008666,12.5 L21.1316787,18.2327123 C19.7537518,20.4458933 16.808659,21.15544 14.5341671,19.8402828 C13.852942,19.4463848 13.2804719,18.8946951 12.8683213,18.2327123 Z"
  }))))))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#AE9977",
    cx: 27.5,
    cy: 20.5,
    r: 3.5
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceConflict);
export default __webpack_public_path__ + "static/media/licence-conflict.30982511bc5bc603a6644e44ce0140ad.svg";
export { ForwardRef as ReactComponent };